// extracted by mini-css-extract-plugin
module.exports = {"total":"mutation_total__32yQf"};